// AI Generated Component
import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { PagePerformancePageDetailsService } from '../../services/page-performance-page-details/page-performance-page-details.service';
import { PagePerformanceCategoryService } from '../../services/category/category.service';
import { PAGE_PERFORMANCE_CATEGORY } from '../../constants/page-performance-category';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { PagePerformanceResultsRepoService } from '@client/app/services/api/page-performance/page-performance-results-repo/page-performance-results-repo.service';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { PagePerformanceVersionService } from '../../services/page-performance-version/page-performance-version.service';


@Component({
    selector: 'page-performance-page-details-dashboard',
    standalone: false,
    template: `
        <div class="row page-details-page-performance-dashboard-container">
            <div class="col-48 d-flex">
                <div class="align-self-center mt-3 mb-2 ml-auto">
                    <csv-export-button [exports]="exports" clsMargin="ml-1" clsSize="py-2 px-3"></csv-export-button>
                </div>
            </div>
            <div class="col-48">
                <div class="card panel-monsido-card">
                    <div class="card-header">
                        <h3 class="card-title" translate>Performance Score</h3>
                    </div>
                    <div class="card-body ml-1 mr-3">
                        <div class="row align-items-center">
                            <div class="col-48 col-lg-16 col-xl-12 d-flex align-items-center justify-content-center justify-content-lg-start performance-score-doughnut-indicators">
                                <page-performance-score-doughnut-chart *ngIf="pagePerformanceScore !== null" [score]="pagePerformanceScore"></page-performance-score-doughnut-chart>
                                <page-performance-score-indicators class="ml-5 mt-2"></page-performance-score-indicators>
                            </div>
                            <div class="col-48 col-lg-16 col-xl-18 align-self-start mt-3 performance-score-line-chart">
                                <page-performance-score-line-chart
                                    [milestones]="timelineMilestones"
                                    [data]="performanceScoreLineData"></page-performance-score-line-chart>
                            </div>
                            <div class="col-48 col-lg-16 col-xl-18 mt-2">
                                <page-performance-opportunities-by-impact [audits]="audits"></page-performance-opportunities-by-impact>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-48">
                <div class="card panel-monsido-card">
                    <div class="card-header">
                        <h3 class="card-title" translate>User Loading Experience</h3>
                    </div>
                    <div class="card-body ml-3 mr-3">
                        <div class="mb-5">
                            <page-performance-page-details-load-sequence [report]="report"></page-performance-page-details-load-sequence>
                        </div>
                        <page-performance-page-details-load-times-trend *ngIf="history"
                                                                        [history]="history"
                                                                        [report]="report">
                        </page-performance-page-details-load-times-trend>
                    </div>
                </div>
            </div>
        </div>
    `,
})
export class PagePerformancePageDetailsDashboardComponent implements OnInit, OnDestroy {
    @Input() page: any;
    @Input() report: any;
    @Input() profile: any;

    @Output() onResultChange = new EventEmitter<any>();
    @Output() goToSection = new EventEmitter<any>();

    audits: any[] = [];
    timelineMilestones: any[] = [];
    pagePerformanceScore: any = null;
    exports: any[] = [];
    history: any;
    performanceResults: any;
    performanceScoreLineData: any;
    lastCheck: any;

    private setReportEventId: any;
    private setProfileEventnId: any;

    constructor (
        private pagePerformancePageDetailsService: PagePerformancePageDetailsService,
        private pagePerformanceCategoryService: PagePerformanceCategoryService,
        private monEventService: MonEventService,
        private pagePerformanceResultsRepoService: PagePerformanceResultsRepoService,
        private translateService: TranslateService,
        private pagePerformanceVersionService: PagePerformanceVersionService,
    ) {}

    ngOnInit () {
        this.audits = [];
        this.timelineMilestones = [];
        this.pagePerformanceScore = null;
        this.setExports();

        if (!this.getLoadingStatus()) {
            this.setAuditsCollection();
        }

        if (this.profile) {
            this.getPerformanceResults(this.profile);
        }

        this.setReportEventId = this.monEventService.addListener('pagePerformancePDAfterSetReport', () => {
            this.setAuditsCollection();
        });

        this.setProfileEventnId = this.monEventService.addListener('pagePerformanceSelectProfile' as any, (profile: any) => {
            this.getPerformanceResults(profile);
        });
    }

    ngOnDestroy () {
        this.monEventService.remove(this.setReportEventId);
        this.monEventService.remove(this.setProfileEventnId);
    }

    getLoadingStatus () {
        return this.pagePerformancePageDetailsService.getLoadingReportStatus();
    }

    onOpportunityClick (section: any) {
        this.goToSection.emit({ active: section });
    }

    private setAuditsCollection () {
        this.audits = this.pagePerformanceCategoryService.getAuditsFromCategory(PAGE_PERFORMANCE_CATEGORY.PERFORMANCE) || [];
    }

    private getPerformanceResults (profile: any) {
        const params: any = {
            page_id: this.page.id,
            profile_id: profile.id,
            limit: 8, //  The "Timeline" and "Load Times Trend" will be shown a clean design on a screen resolution of 1366x768 or above.
        };

        this.pagePerformanceResultsRepoService.getAll(params, {}).then((res: any) => {
            this.history = res;
            this.performanceResults = res.reverse();
            this.performanceScoreLineData = this.performanceResults.map((entry: any) => {
                return {
                    score: entry.performance || 0,
                    time: entry.scanned_at,
                };
            });
            this.timelineMilestones = this.pagePerformanceVersionService.getEntriesWithVersionChanged(this.performanceResults, 'version').map(
                (entry: any) => {
                    const versionInfo = this.pagePerformanceVersionService.getVersionInfo(entry.version);
                    return {
                        text: versionInfo && (versionInfo as any).label ? (versionInfo as any).label : '',
                        link: versionInfo && (versionInfo as any).link ? (versionInfo as any).link : '',
                        date: entry.scanned_at,
                    };
                },
            );
            this.lastCheck = this.performanceResults[this.performanceResults.length - 1] || null;
            this.pagePerformanceScore = this.lastCheck ? this.lastCheck.performance * 100 : 0;
            this.onResultChange.emit({ lastCheck: this.lastCheck });
        }, () => {
            // angular.noop equivalent - empty error handler
        });
    }

    private setExports () {
        const categoryRef = [this.page.id];

        this.exports = [
            {
                name: this.translateService.getString('Performance Scans'),
                data: {
                    category: 'page_performance_results',
                    category_ref: categoryRef.join(),
                },
            },
        ];
    }
}
